export default __webpack_public_path__ + "static/media/assemblySim3.53244578.jpg";